import { FormControlProps, QuestionModel } from 'src/api';

/**
 * <RadioRedesign /> props type
 */
type RadioRedesignProps = FormControlProps & {
  /**
   * Radio label
   */
  label?: string;
  /**
   * Radio image
   */
  image?: string;
  imageStyle?: string;
  /**
   * Question
   */
  question?: QuestionModel;
  /**
   * On change handler
   */
  onChange: (question: QuestionModel | null, value: string) => void;
  /**
   * Classes
   */
  classes?: {
    root?: string;
    flag?: string;
    label?: string;
    image?: string;
  };
};

/**
 * <RadioRedesign /> props
 */
const useRadioRedesignProps = ({
  label,
  question,
  disabled,
  onChange
}: Partial<RadioRedesignProps>) => {
  const _onClick = () => {
    if (disabled || !onChange) return;

    onChange(question || null, label || '');
  };

  return { _onClick };
};

export { useRadioRedesignProps };
